module.exports = __webpack_public_path__ + "img/photo_books_3.127e721a.png";